<template>
  <div class="main-wrapper plantform-video" v-loading="!hadGotVideoPaht">
    <p class="main-wrapper__title">{{ title}}</p>
    <div class="main-wrapper__container">
      <video-player
        v-if="videoPath"
        :video-path="videoPath"
        :start-time="startTime"
        :end-time="endTime"
        :width="900"
        :height="500"
        :video-type="'plantForm'"
        :comment-list="commentList"
        showBarrageEmitName="showBarrage"
        @showBarrage="showBarrage"
        @updateComment="updateComment"
      ></video-player>
      <v-barrage :arr="arr" :isPause="isPause" :percent="40"></v-barrage>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/H5Video/index'
import VBarrage from '@/components/VBarrage/index.vue'
import { getCommentListApi, getClassH5UrlByIDApi } from '@/api/plantform/task'
import { $Cookies } from '@/utils';
export default {
  name: 'PlayVideo',
  components: { VideoPlayer, VBarrage },
  data() {
    return {
      videoPath: '',
      startTime: '',
      endTime: '',
      commentList: [],
      arr: [],
      isPause: false,
      uid: Number($Cookies.get('uid')),
      id: null,
      title: '',
      videoZoneTime: 0, // 视频时长
      hadGotVideoPaht: false, // 视频是否获取到链接，用于加载体验优化
      comObj: {}, // 评论列表对象，键为时间戳
    }
  },
  mounted() {
    this.title = unescape(this.$route.query.title)
    this.id = this.$route.params.id;
    this.getClassH5UrlByID();
    this.getCommentList()
  },
  methods: {
    //评论列表
    getCommentList() {
      const params = {
        distinguish: 3,
        uid: this.uid,
        type: 1,
        id: Number(this.id)
      }
      getCommentListApi(params).then(data => {
        if (data.success && data.result) {
          this.commentList = data.result;
          this.buildComment(this.commentList)
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },

    //生成弹幕
    buildComment(v) {
      v = v.sort((x, y) => y.createTime - x.createTime)
      this.comObj = {};
      v.forEach((item) => {
        if (!this.comObj[item.evaluateTime])
          this.comObj[item.evaluateTime] = []
        this.comObj[item.evaluateTime].push(item.evaluateContent)
      });
    },

    /**
     * @description 展示弹幕, currentTime 是字符串时： 弹幕为服务器获取； 是 true时，为用户实时弹幕
     */
    showBarrage(currentTime, content) {
      if (typeof currentTime === 'string') {
        if (currentTime.length === 5) currentTime = '00:' + currentTime
        this.comObj[currentTime] &&
        (this.comObj[currentTime].forEach(item => {
          this.arr.push({
            direction: 'default',
            content: item
          })
        }))
      } else {
        this.arr.push({
            direction: 'default',
            content: content
          })
      }
    },

    //视频地址
    getClassH5UrlByID() {
      const params = {
        uid: this.uid,
        classVideoId: this.id
      }
      getClassH5UrlByIDApi(params).then(data => {
        if (data.success) {
          const { startTime, endTime, url } = data.result;
          this.startTime = startTime;
          this.endTime = endTime;
          this._handleZoneEntTime("00:10:52")
          this.videoPath = url
          this.hadGotVideoPaht = true
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },

    //更新评论列表
    updateComment(v) {
      if (v) {
        this.getCommentList();
      }
    },

    // 获取视频时间 单位： s
    _handleZoneEntTime(endTime) {
      const timeArr = endTime.split(':');
      if (timeArr.length === 3) {
        this.videoZoneTime = timeArr.length === 3
          ? Number(timeArr[0]) * 60 * 60 + Number(timeArr[1]) * 60 + Number(timeArr[2])
          : this.videoZoneTime = Number(timeArr[0]) * 60 + Number(timeArr[1])
      }
    }
  }
}
</script>